const animate = function(animation) {
  return new Promise(function(resolve) {
    window.requestAnimationFrame(function() {
      animation();
      resolve();
    });
  });
};

const waitForTransition = function(el) {
  return new Promise((resolve) => {
    const complete = function() {
      el.removeEventListener('transitionend', complete);
      resolve(el);
    };

    el.addEventListener('transitionend', complete);
  });
};

export default {
  animate,
  waitForTransition,
};
